const f = {
  color: {
    dragHandler: {
      default: {
        color: "#314351ff",
        bg: "transparent"
      },
      active: {
        color: "#556575ff",
        bg: "#f1f3f5ff"
      },
      disabled: "#abb9c7ff"
    }
  }
};
export {
  f as sortable
};
